export const IMAGES = {
  portrait: "https://customer-assets-0z36b82j.emergentagent.net/job_mongo-sso-site/artifacts/f4bx1eze_Profile%20Photo%20chatgrp%20real.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/8f2b01fa-45fc-4563-a263-420554666e1a/images/e058083b296566570f07c772db94154b967a9ce267a2c53ee7a9ce7f89f95121.jpeg",
  workshop: "https://images.unsplash.com/photo-1555069855-e580a9adbf43?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior: "https://images.unsplash.com/photo-1759050427122-eaeb5885eaf7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
